// extracted by mini-css-extract-plugin
module.exports = {"Setting":"Setting_Setting__7BbnU","flex":"Setting_flex__2fa4r","label":"Setting_label__21FOb","action":"Setting_action__81GV4"};